var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExportinline = function SvgExportinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.033.111a.417.417 0 0 0-.7.305v2.917C10.918 3.42 5 4.333 5 11.243a.416.416 0 0 0 .305.402q.054.018.112.021a.41.41 0 0 0 .355-.2C7 9.46 9.542 8.408 13.333 8.333v2.916a.417.417 0 0 0 .7.306l5.834-5.417a.415.415 0 0 0 0-.61z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.333 11.667a1.667 1.667 0 0 0-1.666 1.666v3.334H3.333V3.333h3.334a1.667 1.667 0 1 0 0-3.333H3.333A3.333 3.333 0 0 0 0 3.333v13.334A3.333 3.333 0 0 0 3.333 20h13.334A3.333 3.333 0 0 0 20 16.667v-3.334a1.667 1.667 0 0 0-1.667-1.666"
  })));
};
export default SvgExportinline;